const DEFAULT_PARAMETERS = {
  theme: 3
}

export const getFilterSearchParameters = () => {
  const url = new URL(location.href)
  const params = url.searchParams

  const theme = params.get('theme') ?? DEFAULT_PARAMETERS.theme
  const min = params.get('min')
  const max = params.get('max')

  const filterParams = Object.fromEntries(
    Object.entries({
      theme,
      min,
      max
    }).filter(([_, v]) => v != null)
  ) as Record<string, string>

  return filterParams
}
